const BirthdayProductsListSkeleton = () => {
  return <div className='homepage-container absolute right-0 top-0 flex h-[250px] gap-2 lg:h-[366px]' data-sentry-component="BirthdayProductsListSkeleton" data-sentry-source-file="skeleton.tsx">
            {Array(6).fill(null).map((_, index) => <div key={index} className='birthday-products-list-skeleton h-full w-39 shrink-0 bg-[var(--landing-skeleton-pulse)] lg:w-52' />)}
        </div>;
};
export default BirthdayProductsListSkeleton;